import axiosInstance from '../../../../../../utils/axios';
import { DateCountDTO } from './models';
import { FailedChallengesApiError } from './errors';

const getFailedChallenges = async (
  token: string,
  timeframe: string = 'TODAY',
): Promise<DateCountDTO[]> => {
  try {
    const response = await axiosInstance.get<DateCountDTO[]>(
      `/v2/admin/full-dashboard/chart/failed`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        params: {
          timeframe,
        },
      },
    );
    return response.data;
  } catch (error: any) {
    throw new FailedChallengesApiError(error.message);
  }
};

export default getFailedChallenges;
